module.exports = new __parcel__URL__("warehouse.5ae8b843.jpg").toString();